@if (isBadgesShown()) {
  @let isSmall = size() === 'sm';
  @let badgeBase =
    'w-fit rounded-full bg-light-main text-light-contrast ' +
    (isSmall ? 'px-2 py-1 text-sm leading-5' : 'px-5 py-2.5 text-base leading-8 md:leading-10');

  <div
    class="p pointer-events-auto absolute z-30 flex flex-wrap"
    [ngClass]="[isSmall ? 'left-2 top-2 gap-1.5' : 'left-5 top-5 gap-3.5 md:left-9 md:top-7 md:gap-2.5']"
  >
    <!-- ItemType Badge -->
    @if (showItemTypeBadge() && getTeaserBadgeLabel(itemType()) !== '') {
      <div [class]="badgeBase">
        {{ getTeaserBadgeLabel(itemType()) }}
      </div>
    }

    <!-- New Badge -->
    @if (isNewArticle()) {
      <div [class]="badgeBase">
        {{ 'components.searchGallery.teaser-badge.new' | translate }}
      </div>
    }

    <!-- Discount Badge -->
    @if (showDiscountBadge() && isDiscountBadge()) {
      <div [class]="badgeBase">
        <span>
          @if (isBadgeAbsolute() && priceDifference() && currency()) {
            <span class="mr-1">{{ priceDifference() }} {{ currency() }}</span>
          } @else {
            {{ badgeValue() ?? '' }}
          }
        </span>
      </div>
    }

    <!-- Available Badge -->
    @if (showAvailableStatusBadge() && (itemType() === 'Article' || itemType() === 'Event')) {
      @if (isAvailableArticle()) {
        <div [class]="badgeBase">
          {{ 'components.searchGallery.teaser-badge.available' | translate }}
        </div>
      } @else {
        <div [class]="badgeBase">
          {{ 'components.searchGallery.teaser-badge.notAvailable' | translate }}
        </div>
      }
    }

    <!-- Article Teaser Badge -->
    @if (showArticleTeaserBadge() && articleTeaser()) {
      @let teaser = articleTeaser();
      @let teaserColor = teaserColors(articleTeaserColor());
      @let isNewsDefault = itemType() === 'News' && !teaserColor;
      <div [class]="badgeBase" [style.background-color]="isNewsDefault ? '#cab4d6' : teaserColor?.main">
        @if (teaser) {
          <span class="mr-1" [class.text-primary-main]="isNewsDefault" [style.color]="isNewsDefault ? null : teaserColor?.contrast">
            {{ teaser }}
          </span>
        }
      </div>
    }
  </div>
}
